// window.onload = function () {
// //SLIDER


//    new Slider({
//       images: '.tours__cards .tours__card',
//       btnPrev: '.1tours__btnleft',
//       btnNext: '.1tours__btnright',
//       autoRun: false
//     });

//    new Slider({
//       images: '.gallery-2 .photos img',
//       btnPrev: '.gallery-2 .buttons .prev',
//       btnNext: '.gallery-2 .buttons .next',
//       autoRun: true
//     });

//   function Slider(obj) {
//       this.images = document.querySelectorAll(obj.images);
//       this.btnPrev = document.querySelector(obj.btnPrev);
//       this.btnNext = document.querySelector(obj.btnNext);
//       this.autoRun = obj.autoRun;

//       var context=this;


//       this.next = function () {
//           for(var j=0; j<2; j++){
//             var tourOrder=Number(this.images[j].dataset.order);
//             this.images[j].dataset.order=tourOrder+1;
//           }
//           this.images[2].dataset.order=-1;
//           // this.images[iprev].classList.remove('tours__card__prev');
//           // this.images[i].classList.remove('tours__card__active');
//           // this.images[inext].classList.remove('tours__card__next');
//           i++;
//           if (i > 2) {
//               iprev=2;
//               i = 0;
//               inext=i+1;
//           }
//           else if (i == 0) {
//             iprev = 2;
//             inext=1;
//           }
//           else if (i==2) {
//             iprev = 1;
//             inext = 0;
//           }
//           else
//           {
//             iprev=i-1;            
//             inext=i+1;
//           }

//           // this.images[iprev].classList.add('tours__card__prev');
//           // this.images[i].classList.add('tours__card__active');
//           // this.images[inext].classList.add('tours__card__next');
//       }

//       if(this.autoRun){
//         // setInterval(function() {
//         // context.next();
//         // }, 1000);
//       } else {
//         this.btnPrev.onclick = function(){
//            context.prev();
//         }
//         this.btnNext.onclick = function(){
//              context.next();
//         }   
//       }
//   }
// }


  // var num1=document.querySelector('input[name=num1]');
  // var num2=document.querySelector('input[name=num2]');
  // var btn=document.querySelector('input[name=calc]');
  // var res=document.querySelector('.res');
  // var datachanges=document.querySelectorAll('.datachange');

  //   btn.onclick=function(){
  //     var oper=document.querySelector('select');
  //     btn.disabled=true;
  //     for(var i=0; i<datachanges.length; i++){
  //       datachanges[i].oninput=function(){
  //         btn.disabled=false;
  //       }        
  //     }
  //     var operact=oper.value;
  //     // res.innerHTML=parseInt(num1.value).+.operact.&.parseInt(num2.value);
  //     if (oper.value=='+'){
  //       res.innerHTML=parseInt(num1.value)+parseInt(num2.value);
  //     }
  //     else if (oper.value=='-'){
  //       res.innerHTML=parseInt(num1.value)-parseInt(num2.value);
  //     }
  //     else if (oper.value=='*'){
  //       res.innerHTML=parseInt(num1.value)*parseInt(num2.value);
  //     }
  //     else if (oper.value=='/'){
  //       res.innerHTML=parseInt(num1.value)/parseInt(num2.value);
  //     }
  //   }





    // var inputs = document.querySelectorAll('input');
    // var btn = document.querySelector('form');
    
    // function validateForm(e){
    //   var err=false;
    //   for(var i = 0; i < inputs.length-1; i++){
    //    if(inputs[i].value==0)
    //    {
    //     err=true;
    //     inputs[i].classList.add('notvalid');
    //    }
    //    else{
    //     inputs[i].classList.remove('notvalid');
    //    }
    //   }
    //   if(err){
    //     e.preventDefault();
    //   }
    // }


    // btn.onsubmit= validateForm;

    
    // var images = document.querySelectorAll('.gallery img');
    
    // for(var i = 0; i < images.length; i++){
    //     images[i].onmousedown = stopMove;
    //     images[i].oncontextmenu = stopMove;
    // }
    
    // function stopMove(e){
    //     return false;
    // }











$(document).ready(function () {
  var d = new Date();
  var output = d.getFullYear();
  $('.yearval').text(output);
  accordion();
});



//Preloader
$(window).on('load', function() {
  $("#over").fadeOut().remove();
  $("#preload").delay(550).fadeOut("slow").remove();
  $(".main__h1").addClass("animation--title-in");
  $(".main__subtitle").addClass("animation--subtitle");
  $(".main__slider").addClass("animation--slider");
  $(".about__h2").addClass("title-animated");  
});
//End Preloader




$(document).ready(function(){
    $('.main__slider').slick({
      slidesToShow: 1,
      touchThreshold:20,
      centerMode: true,
      fade: true,
      autoplaySpeed:3000,
      cssEase: 'linear',
      // centerPadding:'0 px',
      autoplay:true,
      // arrows:false,
      prevArrow:'.tours__btnleft',
      nextArrow:'.tours__btnright',
      //appendDots: $('.main__slider__dots'),
    });
});


// $(document).ready(function(){
//     $('.tours__cards1').slick({
//       slidesToShow: 1,
//       touchThreshold:20,
//       // centerMode: true,
//       centerPadding:'0px',
//       arrows: true,
//       variableWidth: true,
//       useCSS:false,
//       useTransform:false,
//       // autoplay:true,
//       // dots:true,
//       // appendArrows: $('.aboutrooms__slider__arrows'),
//       // appendDots: $('.aboutrooms__slider__dots'),
//       // customPaging: function (slider, i) {
//       //   return  '<span class="slick-current">' + (i + 1) + ' </span><span class="slick-total">' + slider.slideCount + ' </span>';
//       // },
//       prevArrow:'.tours__btnleft',
//       nextArrow:'.tours__btnright',
//     });
// });

$(document).ready(function(){
  $('.tours .tours__cards').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'.tours__btnleft',
    nextArrow:'.tours__btnright',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding:'0',
          centerMode: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});


$(document).ready(function(){
  $('.prices .tours__cards').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'.tours__btnleft',
    nextArrow:'.tours__btnright',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding:'0',
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});





// $(document).ready(function(){
//     $(".slick-current").prev().addClass('tours__card__prev');
//     $(".slick-current").next().addClass('tours__card__next');
//   $(".tours__btnright").click(function () {
//     $(".tours__card__prev").removeClass('tours__card__prev');
//     $(".tours__card__next").removeClass('tours__card__next');
//     $(".slick-current").prev().addClass('tours__card__prev');
//     $(".slick-current").next().addClass('tours__card__next');
//   });
// });

// $(document).ready(function(){
//   $(".tours__btnleft").click(function () {
//     $(".tours__card__prev").removeClass('tours__card__prev');
//     $(".tours__card__next").removeClass('tours__card__next');
//     $(".slick-current").prev().addClass('tours__card__prev');
//     $(".slick-current").next().addClass('tours__card__next');
//   });
// });


//- Menu close/open
$(document).ready(function () {
	$(".menu-button").click(function () {
		$(this).toggleClass("menu-button--to-open"),
		$(this).toggleClass("menu-button--to-close"),
		$(this).hasClass("menu-button--to-close") ? $(".menu").addClass("menu--visible") : $(".menu").removeClass("menu--visible")
	})
});

//- При изменении ширины окна браузера на ширине 1200px сворачивается меню, если оно было развернуто.
//- срабатывает событие клика на кнопку, чтобы и меню, и кнопка приняли необходимый вид для широких экранов
$(window).resize(function(){
	if($(window).width()>=1280){
		if($('.menu').hasClass('menu--visible')){
			$('.menu-button').click();
		}
	}
});




// $(document).ready(function(){
//   $(".timeline__item").click(function (){
//      $(".timeline__item").removeClass("timeline__item__active");
//       $(this).addClass("timeline__item__active")
//   });
// });



$(document).ready(function(){
  $(".btn--more").click(function (){
     $(".row-to-hide").removeClass("row-to-hide");
     $(".archive-lessons__btn").addClass("hidden");
  });
});



$(window).resize(function(){
   $('.sub-menu').removeClass('sub-menu--visible');
});


$(document).ready(function(){
    $('.menu-list__rooms').mouseover(function () {
      if($(window).width()>=1280){
        $(this).find('.sub-menu').addClass('sub-menu--visible');
      }
    });
    $('.menu-list__rooms').mouseout(function () {
      if($(window).width()>=1280){
        $(this).find('.sub-menu').removeClass('sub-menu--visible');
      }
    });
    $('.menu-list__rooms').click(function (e) {
      // e.preventDefault();
      $(this).find('.sub-menu').toggleClass('sub-menu--visible');
    })    

});



// var scene = new ScrollMagic.Scene();

// var scene = new ScrollMagic.Scene({
//   triggerElement: '#about', // starting scene, when reaching this element
//   duration: 400 // pin the element for a total of 400px
// })
// .setPin('.about__left'); // the element we want to pin

// // Add Scene to ScrollMagic Controller
// controller.addScene(scene);

// var controller = new ScrollMagic.Controller();

// var scene1 = new ScrollMagic.Scene({
//               triggerElement: ".title-animated",
//               triggerHook: 1,
//               offset: 1, // move trigger to center of element
//               // reverse: false // only do once
//             })
// .setClassToggle(".title-animated", "animation--red") // add class toggle
// .addIndicators() // add indicators (requires plugin)
// // .addTo(controller);


// var scene2 = new ScrollMagic.Scene({
//               triggerElement: ".title-animated",
//               triggerHook: 1,
//               offset: 1, // move trigger to center of element
//               // reverse: false // only do once
//             })
// .setClassToggle(".title-animated", "go") // add class toggle
// .addIndicators() // add indicators (requires plugin)
// // .addTo(controller);

// var scene3 = new ScrollMagic.Scene({
//               triggerElement: ".title-animated",
//               triggerHook: 1,
//               offset: 1, // move trigger to center of element
//               // reverse: false // only do once
//             })
// .setClassToggle(".text-animated", "animation--text") // add class toggle
// .addIndicators() // add indicators (requires plugin)
// // .addTo(controller);

// var scene4 = new ScrollMagic.Scene({
//               triggerElement: ".animated-frame",
//               triggerHook: 1,
//               offset: 200, // move trigger to center of element
//               // reverse: false // only do once
//             })
// .setClassToggle(".animated-frame", "animated-frame--no") // add class toggle
// .addIndicators() // add indicators (requires plugin)


// Add Scenes to ScrollMagic Controller
// controller.addScene([
//   scene1,
//   scene2,
//   scene3,
//   scene4
// ]);



// var controller = new ScrollMagic.Controller();
//     $(".fadetest").each(function(){
//         var elem=this;
//         var tween = TweenMax.to(".fadetest", {fontWeight: 700}
//                     );
//         var scene = new ScrollScene({
//                 duration: 200,
//                 triggerElement: ".fadetest",
//                 offset: 200,
//                 triggerHook: 1,
//             })
//             .setTween(tween)
//             .addTo(controller)
//             .addIndicators();
//     });


// $('fadetest').each(function(){
//     var currentStrong = this;

//     var tweenStrong = new TimelineMax()
//         .to(currentStrong, 0.25, {css: {fontWeight: 700, color: red)}});

//     var scene = new ScrollScene({triggerElement: currentStrong, offset: 200})
//         .setTween(tweenStrong)
//         .addTo(controller);
// });



// $(function() {
//     controller = new ScrollMagic();
//     $(".animate").each(function (index, elem) {
//         var tween = TweenMax.to(elem, 0.5,
//                                {scale: 1.02, backgroundColor: 'rgb(255, 39, 46)' }
//                     );
//         new ScrollScene({
//                 duration: 200,
//                 triggerElement: elem,
//                 triggerHook: "onCenter",
//             })
//             .setTween(tween)
//             .addTo(controller)
//             .addIndicators();
//     });
// });




// var ctrl = new ScrollMagic.Controller();

// // Create scenes in jQuery each() loop
// $("section").each(function(i) {
//   var inner = $(this).find(".inner");
//   var outer = $(this).find(".outer");
//   var tl = new TimelineMax();
  
//   tl.from(outer, 0.25, { fontWeight: 400 });
//   tl.from(inner, 0.65, { fontWeight: 700 });
  
//   new ScrollMagic.Scene({
//     triggerElement: this,
//     triggerHook: 0.15
//   })
//     .setTween(tl)
//     .addIndicators({
//       colorTrigger: "white",
//       colorStart: "white",
//       colorEnd: "white",
//       indent: 40
//     })
//     .addTo(ctrl);
// });


var ctrl = new ScrollMagic.Controller();

//Create scenes in jQuery each() loop
$(".animated-frame").each(function(i) {
  var inner = $(this);
  var tl = new TimelineMax();
  
  tl.to(this, 0.65, {className: '+=animated-frame--no'});
  
  new ScrollMagic.Scene({
    triggerElement: this,
    triggerHook: 1,
    offset:200,
    reverse:false,
  })
    .setTween(tl)
    // .addIndicators({
    //   colorTrigger: "white",
    //   colorStart: "white",
    //   colorEnd: "white",
    //   indent: 40
    // })
    .addTo(ctrl);
});


$(".title-animated").each(function(i) {
  var tl2 = new TimelineMax();
  
  tl2.to(this, 0.35, {className: '+=animation--red go'});
  
  new ScrollMagic.Scene({
    triggerElement: this,
    triggerHook: 1,
    offset:0,
    reverse:false,
  })
    .setTween(tl2)
    // .addIndicators({
    //   colorTrigger: "white",
    //   colorStart: "white",
    //   colorEnd: "white",
    //   indent: 40
    // })
    .addTo(ctrl);
});

// var scene3 = new ScrollMagic.Scene({
//               triggerElement: ".title-animated",
//               triggerHook: 1,
//               offset: 1, // move trigger to center of element
//               // reverse: false // only do once
//             })
// .setClassToggle(".text-animated", "animation--text") // add class toggle
// .addIndicators() // add indicators (requires plugin)
// // .addTo(controller);

$(".text-animated").each(function(i) {
  var tl3 = new TimelineMax();
  
  tl3.to(this, 0.65, {className: '+=animation--text'});
  
  new ScrollMagic.Scene({
    triggerElement: this,
    triggerHook: 1,
    offset:-100,
    reverse:false,
  })
    .setTween(tl3)
    // .addIndicators({
    //   colorTrigger: "white",
    //   colorStart: "white",
    //   colorEnd: "white",
    //   indent: 40
    // })
    .addTo(ctrl);
});




$("#bookingIt").submit(function (event) {
  var idForm="#bookingIt";
  event.preventDefault();
    if ($(this)[0].checkValidity() === false) {
      event.stopPropagation();
      $(idForm).addClass('was-validated');
      $(".form-result").css("display", "none");
      $(".result_error_fields").css("display", "block");
      var c = $(this).attr("href"),
      t = $(".form-result").offset().top - 50;
      $("body,html").animate({
        scrollTop: t
      }, 500)
      return(false);
    } else {
      doajax(idForm);
      $(this).removeClass("was-validated");
        var c = $(this).attr("href"),
      t = $(".form-result").offset().top - 50;
      $("body,html").animate({
        scrollTop: t
      }, 500)
    }
});


//- Аккордеон
function accordion() {
  $('.spoiler-body').hide();
  $(".spoiler-wrap").click(function(e) {
    e.preventDefault();
    var $spoilerBody = $(this).find('.spoiler-body'),
        $spoilerHead = $(this).find('.spoiler-head');

    if ($(this).hasClass('active')) { //- если кликнули по открытой ссылке
      $spoilerBody.slideToggle();
      //$spoilerHead.removeClass("icon-minus").addClass("icon-plus");
      $(this).removeClass('active');
    } else { //- если кликнули по закрытой ссылке
      $('.spoiler-wrap').removeClass('active').find('.spoiler-body').slideUp();
      //.find('.spoiler-head').removeClass("icon-minus").addClass("icon-plus");
      $(this).addClass('active');
      //$spoilerHead.removeClass("icon-plus").addClass("icon-minus");
      $spoilerBody.slideToggle();
    }
  });
}


/*--------------------------------------------------------*/
/*--------------ОТПРАВКА ДАННЫХ НА СЕРВЕР-----------------*/
/*----------------(общая для всех форм)-------------------*/
/*--------------------------------------------------------*/

function doajax(activeform) {
  var t, a = $(activeform).serialize();
  var o=$(activeform).attr('action');
  $.ajax({
    type: "POST",
    url: o,
    data: a,
    success: function (msg) {
      msg=$.trim(msg); //- удаляем лишние пробелы, символы, иначе из php файла получим строку success, которая не соответствует строке success в этом файле
      if (msg=="success") //сообщение успешно отправлено
        $(".form-result").css("display", "none"),
        $(".result_success").css("display", "block"),
        $(activeform)[0].reset()
      else if (msg=="failed") //сообщение не отправлено из-за ошибки на сервере
        $(".form-result").css("display", "none"),
        $(".result_error_server").css("display", "block"),
        $(activeform)[0].reset()
      else if (msg=="robot") //сообщение не отправлено, нет подтверждения что не робот
        $(".form-result").css("display", "none"),
        $(".result_error_robot").css("display", "block")
      else //есть незаполненные поля, сообщение не отправлено (непустая $errorMSG в php-скрипте)
        $(".form-result").css("display", "none"),
        $(".result_error_fromphp").css("display", "block"),
        $(".result_error_fromphp").text(msg)
    },
    beforeSend: function () {
      $(activeform).find(":input").attr("disabled", !0),
      $(activeform + " .ajax-loader").css("display", "block")
    },
    complete: function () {
      $(activeform).find(":input").attr("disabled", !1),
      $(activeform + " .ajax-loader").css("display", "none")
    }
  });
}